import {_, React, classNames, StyledProps} from '@api'
import {CustomAttributeDefinition} from '@api/graphql'
import {GroupInfoCardMoreMenuButton} from '@modules'
import {Card, CardActions, Tooltip} from '@material-ui/core'
import {ToggleInfoPanelButton} from '@modules/common/components/InfoCards/ToggleInfoPanelButton'
import {computed} from 'mobx'
import * as css from './CustomAttributeInfoCard.css'
import {StoresInstance, ui} from '@stores'
import {observer} from 'mobx-react'

interface MyProps extends StyledProps {
  info: { title?: React.ReactNode, subtitle1?: React.ReactNode }
  def: CustomAttributeDefinition
  //productCount: number
  titleCount?: React.ReactNode
  offlineItemsCount?: React.ReactNode
  leftActions?: React.ReactNode
  rightActions?: React.ReactNode
  extra?: React.ReactNode
  isSelected?: boolean
  groupView?: 'flat' | 'card' | 'pivot'
  onDrop?: (e) => void
  data?: any
  type?: string
  specStack?: any
  isUnassigned?: boolean
  products?: any
  level?: number
  toggleInfoPanel?: () => void
  infoPanelActive?: boolean
  group?: any
  path?: any
  stores: StoresInstance
}

@observer
export class CustomAttributeInfoCard extends React.Component<MyProps> {
  render() {
    const {
        props: {
          leftActions,
          rightActions,
          className,
          titleCount,
          offlineItemsCount,
          groupView,
          data,
          specStack,
          isUnassigned,
          products,
          level,
          toggleInfoPanel, infoPanelActive,
          group,
          path, extra
        }
      } = this

    return (
      <Card
        data-level={level}
        data-style={groupView}
        data-type='CustomAttributeInfoCard'
        className={classNames(css.root, className)}>
        {leftActions && groupView == 'card' &&
		 <CardActions className={classNames(css.actions)}>
           {leftActions}
			 <GroupInfoCardMoreMenuButton className={classNames(css.extraMenu)} group={group} path={path} specStack={specStack} isUnassigned={isUnassigned} items={products} isCustomAttribute level={level}/>
		 </CardActions>}

        <div data-type='left-title' className={css.labelAndCount}>
          {groupView == 'flat' && leftActions}
          <div className={css.content}>
            <div className={css.row}>
              {data.title}
              {level == 0 && toggleInfoPanel && <ToggleInfoPanelButton infoPanelActive={infoPanelActive} toggleInfoPanel={toggleInfoPanel}/>}
              {titleCount}
              {offlineItemsCount}
              {groupView == 'flat' && rightActions}
            </div>
            {data.subtitle1 && <div className={css.row}>{data.subtitle1}</div>}
          </div>
        </div>
        {rightActions && groupView == 'card' &&
		 <CardActions className={classNames(css.actions)}>
           {rightActions}
			 <GroupInfoCardMoreMenuButton className={classNames(css.extraMenu)} group={group} path={path} specStack={specStack} isUnassigned={isUnassigned} items={products} isCustomAttribute level={level}/>
		 </CardActions>}

        {extra}
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/InfoCards/CustomAttributeInfoCard.tsx